import { z } from 'zod';
import { ActionSettingSchema } from './actionSetting';

export type MessageState =
  | 'draft'
  | 'deleted'
  | 'approved'
  | 'publishing'
  | 'published'
  | 'revoking'
  | 'revoked';

export const MESSAGE_STATE_VALUES: MessageState[] = [
  'draft', // 未審核
  'deleted', // 已刪除
  'approved', // 已審核
  'publishing', // 發送中
  'published', // 已發送
  'revoking', // 撤回中
  'revoked', // 已撤回
];

export const MESSAGE_STATE_WITH_RESULT: MessageState[] = [
  'published',
  'revoking',
  'revoked',
];

export const MessageStateSchema = z.enum(MESSAGE_STATE_VALUES);

export const NotificationSettingSchema = z.object({
  notification: z.object({
    push_enabled: z.boolean(),
  }),
});

export type SegmentType = 'list_segment' | 'condition_segment';

export type SegmentBuiltinCondition = 'all_user';

export const SegmentSettingSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('list_segment') }),
  z.object({
    type: z.literal('condition_segment'),
    condition: z.enum(['all_user']),
  }),
]);

const MessageCategorySchema = z.object({
  key: z.string(),
  name: z.string(),
  parent: z
    .object({
      key: z.string(),
      name: z.string(),
    })
    .nullable(),
});

const SegmentSnapshotSchema = z.object({
  id: z.string(),
  state: z.string(),
  // 不知道為什麼可能是 "計算中" 跟數字，但前端統一轉比較快，-1 代表沒有正常值
  userCount: z
    .string()
    .or(z.number())
    .pipe(
      z.transform((val) => {
        if (typeof val === 'string') {
          return -1;
        }

        return val;
      }),
    ),
});

export const MessageTemplateSchema = z.object({
  id: z.uuid(),
  segmentSnapshotId: z.uuid().nullish(),
  messageCategoryKey: z.string(),
  messageCategory: MessageCategorySchema,
  notificationId: z.uuid().nullish(),
  name: z.string(),
  title: z.string(),
  summary: z.string(),
  thumbUrl: z.string().nullish(),
  state: MessageStateSchema,
  scheduleAt: z.iso.datetime({ offset: true }).nullable(),
  // TODO remove it if list API correct
  actionSetting: ActionSettingSchema.catch(undefined),
  notificationSettings: NotificationSettingSchema,
  segment: SegmentSettingSchema.nullish(),
  segmentSnapshot: SegmentSnapshotSchema,
  reportUri: z.string().nullish(),
  createdAt: z.iso.datetime({ offset: true }),
  updatedAt: z.iso.datetime({ offset: true }),
});

export type MessageTemplate = z.infer<typeof MessageTemplateSchema>;
